import React from 'react';
import PropTypes from 'prop-types';

import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
} from 'recharts';

import GraphTitle from 'app/shared/components/Graphs/GraphTitle';
import GraphEmptyMessage from 'app/shared/components/Graphs/GraphEmptyMessage';
import SpinnerContainer from 'app/shared/components/SpinnerContainer';

import GraphConstants from 'app/shared/constants/GraphConstants';

// Stylesheets
import 'app/shared/components/Graphs/style.scss';

const propTypes = {
    brand: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
};

const defaultProps = {
    isLoading: false,
};

const GRAPH = GraphConstants.GRAPHS.PROPERTY;
const dataKey = GraphConstants.GRAPH_DATA_TYPES.PROPERTIES;

class ViewGraph extends React.PureComponent {
    renderGraph(currentData) {
        const { brand } = this.props;
        return (
            <div className="Graph-container">
                {currentData.isEmpty && <GraphEmptyMessage message="No listings available" />}
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={currentData.months} key={dataKey}>
                        <XAxis dataKey="name" />
                        <YAxis />
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <Tooltip />
                        <Bar
                            dataKey={dataKey}
                            fill={GraphConstants.COLORS[brand].primary}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        );
    }

    render() {
        const {
            isLoading,
            data,
        } = this.props;
        const configs = GRAPH.default;
        const currentData = isLoading ? 0 : data[configs.DATA_TYPE];

        return (
            <div className="Graph">
                <GraphTitle
                    title={configs.TITLE_PREFIX}
                    isLoading={isLoading}
                />
                {isLoading ? <SpinnerContainer customClass="Graph-Spinner" /> : this.renderGraph(currentData)}
            </div>
        );
    }
}

ViewGraph.propTypes = propTypes;
ViewGraph.defaultProps = defaultProps;

export default ViewGraph;
